import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import { getMixAndMatches } from 'actions/EntityActions';
{/*  COMPONENTS  */ }
import ContainerDivided from 'screens/components/basic/ContainerDivided';
import GenericTable from 'screens/components/advanced/GenericTable';
import Pagination from 'screens/components/basic/Pagination';
import Panel from 'screens/components/basic/Panel';
import Button from 'screens/components/basic/Button';
import WithRouter from 'custom/withRouter';

const componentName = 'mixAndMatchList';

class MixAndMatchList extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            activePage: 1,
            itemsPerPage: 25
        };
    }

    componentWillMount() {
        this.search();
    }
    search = () => {
        this.props.getMixAndMatches(this.state.activePage, this.state.itemsPerPage, this.props.branchId);
    }

    changePage = (e) => {
        this.setState(prevState => {
            return {
                ...prevState,
                activePage: e
            };
        }, this.search);
    }

    redirectToAddPage = () => {
        this.props.navigate("/manage/pricing/mixandmatch/add");
    }

    redirectToEditPage = (id) => {
        this.props.navigate(`/manage/pricing/mixandmatch/edit/${id}`);
    }

    render() {
        const p = this.props;
        const s = this.state;

        const header = (
            <div>
                <ol className="breadcrumb">
                    <li><Link to={LOOKUP.menu.home.link}>{LOOKUP.menu.home.text}</Link></li>
                    <li className="active">{LOOKUP.menu.pricing.mixAndMatch.text}</li>
                </ol>
            </div>);

        const sideContent = (
            <Panel title="Toolbox">
                <div className="row text-center">
                    <Button type="AddButton"
                        className="toolbox-button"
                        label={LOOKUP.mixAndMatch.controls.addMixAndMatch}
                        onTouchTap={this.redirectToAddPage} />
                </div>
            </Panel>
        );

        const tableRows = p.mixAndMatchesList.map(item => {
            return {
                Name: (<Link className="edit-link" to={`/manage/pricing/mixandmatch/edit/${item.id}`}>{item.name}</Link>),
                Period: item.dateTo ? `${moment(item.dateFrom).format('L')} to ${moment(item.dateTo).format('L')}` : `${moment(item.dateFrom).format('L')}`,
                Status: item.status === 1 ? "Active" : "Inactive",
                Buttons: (
                    <Button type="EditButton"
                        label={LOOKUP.mixAndMatch.controls.editButton}
                        primary={true}
                        onTouchTap={this.redirectToEditPage.bind(this, item.id)} />
                )
            };
        });

        return (
            <ContainerDivided headerContent={header} sideContent={sideContent}>
                <div className="form-group">
                    <GenericTable
                        className="table_center"
                        tableBodyClassName="mixandmatches-table"
                        multiSelectable={false}
                        enableSelectAll={false}
                        selectable={false}
                        stripedRows={true}
                        columns={LOOKUP.mixAndMatch.listTableColumns}
                        rows={tableRows} />
                    <Pagination
                        length={p.totalMixAndMatches || 0}
                        itemsPerPage={s.itemsPerPage}
                        activePage={s.activePage}
                        onPageChange={this.changePage} />
                </div>
            </ContainerDivided>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        mixAndMatchesList: state.entity.mixAndMatchesList,
        totalMixAndMatches: state.entity.mixAndMatchesListLength,
        branchId: state.common.branchId
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        getMixAndMatches: (page, itemsPerPage, branchId) => dispatch(getMixAndMatches(page, itemsPerPage, branchId))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(MixAndMatchList));